module.exports = __webpack_public_path__ + "static/media/openstudy_01.292d7b4a.jpg";